// extracted by mini-css-extract-plugin
export default {"label":"SimpleInfo_label__3_tgV","value":"SimpleInfo_value__2leim"};